export default __webpack_public_path__ + "fcb0b692b8290759917a9dc923aac10b.jpg";